<div class="dashboard-container">
    <main class="dashboard-content">
        <!-- Hero Section -->
        <section class="hero-section">
            <div class="hero-banner">
                <!-- Enhanced Background Elements -->
                <div class="background-effects">
                    <!-- Animated Gradient Overlay -->
                    <div class="gradient-overlay"></div>

                    <!-- Geometric Pattern -->
                    <div class="geometric-pattern">
                        <div class="pattern-layer pattern-layer-1"></div>
                        <div class="pattern-layer pattern-layer-2"></div>
                        <div class="pattern-layer pattern-layer-3"></div>
                    </div>

                    <!-- Floating Particles -->
                    <div class="particles-container">
                        <div class="particle" *ngFor="
                                let _ of particleSlots;
                                index as i;
                                trackBy: particleTrackByIndex
                            " [style.animation-delay.s]="i * 0.8"></div>
                    </div>

                    <!-- Chemical Formula Background -->
                    <div class="chemical-formulas">
                        <div class="formula formula-1">H₂SO₄</div>
                        <div class="formula formula-2">C₆H₁₂O₆</div>
                        <div class="formula formula-3">NaCl</div>
                        <div class="formula formula-4">CH₄</div>
                        <div class="formula formula-5">H₂O</div>
                        <div class="formula formula-6">CO₂</div>
                    </div>

                    <!-- Hexagon Pattern -->
                    <div class="hexagon-grid">
                        <div class="hexagon" *ngFor="
                                let _ of hexSlots;
                                index as i;
                                trackBy: trackByIndex
                            " [style.animation-delay.s]="i * 0.3"></div>
                    </div>
                </div>

                <div class="banner-content">
                    <div class="banner-text">
                        <div class="hero-main-content">
                            <div class="title-and-features">
                                <div class="title-section">
                                    <h1 class="hero-main-title">
                                        Valence Chemical Operations Hub
                                    </h1>
                                </div>
                            </div>

                            <!-- Integrated Animated Features -->
                            <div class="integrated-features">
                                <div class="feature-display" *ngFor="
                                        let feature of heroFeatures;
                                        let i = index
                                    " [class.active]="currentFeatureIndex === i" [@slideUpFade]="
                                        currentFeatureIndex === i
                                            ? 'visible'
                                            : 'hidden'
                                    ">
                                    <div class="feature-content">
                                        <div class="feature-icon-title">
                                            <mat-icon class="feature-icon">{{
                                                feature.icon
                                                }}</mat-icon>
                                            <h3 class="feature-name">
                                                {{ feature.title }}
                                            </h3>
                                        </div>
                                        <p class="feature-description">
                                            {{ feature.detailedDescription }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="floating-molecule">
                <img src="assets/images/chemical-shape.webp" alt="Benzene Molecular Structure"
                    class="molecule-graphic-floating" />
            </div>
        </section>

        <section class="charts-dashboard-section">
            <header class="section-header visually-hidden">
                <h2>Dashboard Overview</h2>
            </header>

            <div class="charts-grid">
                <ng-container *ngIf="chartOptions$ | async as chartOptions; else chartsLoading">
                    <!-- Loop through chart requests -->
                    <home-page-chart *ngFor="let chartRequestId of selectedChartIds; let i = index; trackBy: trackByChartIndex"
                        [extraFilters]="newFilters" [chartOptionMenu]="chartOptions"
                        (chartSelected)="selected($event, 'chart', i)" [defaultRequest]="chartRequestId">
                    </home-page-chart>

                    <div *ngIf="chartOptions.length === 0" class="empty-state">
                        <mat-icon>insert_chart_outlined</mat-icon>
                        <p>No chart sources available.</p>
                    </div>
                </ng-container>

                <ng-template #chartsLoading>
                    <div class="empty-state">
                        <mat-icon>hourglass_empty</mat-icon>
                        <p>Loading charts…</p>
                    </div>
                </ng-template>

            <article class="chart-card calendar-card">
                      <mat-calendar class="dashboard-calendar" [(selected)]="selectedDate"
                                (selectedChange)="onDateChange()"></mat-calendar>
            </article>

                <!-- <article class="chart-card calendar-card">
                    <div class="card-body">
                        <div class="calendar-widget">
                            <mat-calendar class="dashboard-calendar" [(selected)]="selectedDate"
                                (selectedChange)="onDateChange()"></mat-calendar>
                        </div>
                    </div>
                </article> -->
            </div>
        </section>

        <ng-container *ngIf="tableReports$ | async as tableOptions; else tableLoading">
            <div class="data-grid-section" *ngFor="let tableRequestId of selectedTableIds; let i = index; trackBy: trackByTableIndex">
                <home-page-table *ngIf="tableOptions.length > 0" [extraFilters]="newFilters"
                    [tableOptionMenu]="tableOptions" [defaultRequest]="tableRequestId"
                    (tableSelected)="selected($event, 'table', i)">
                </home-page-table>

                <div *ngIf="tableOptions.length === 0" class="empty-state">
                    <mat-icon>table_chart</mat-icon>
                    <p>No table sources available.</p>
                </div>
            </div>
        </ng-container>

        <ng-template #tableLoading>
            <div class="empty-state">
                <mat-icon>hourglass_empty</mat-icon>
                <p>Loading tables…</p>
            </div>
        </ng-template>
    </main>
</div>
